// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__WJ6vD","footerTextContainer":"Footer_footerTextContainer__bC02z","footerText":"Footer_footerText__fFYMx"};